
import { Body, Bold, useModal } from '@panwds/react-ui'
import { useCallback, useContext, useMemo } from 'react'
import { ASSOCIATED_TENANTS } from '../constants/SubscriptionConstant'
import TenantInfoModal from '../modals/TenantInfoModal'
import AppContext from '../../../common/context/AppContext'

/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on LinkRenderer.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */


const LinkRenderer = ({ flowType, value, row, ...props }) => {
  const tenantClaimModal = useModal(TenantInfoModal)
  const { getAppName } = useContext(AppContext)
  const openTenantInfoDialog = useCallback(() => {
    tenantClaimModal.openModal({ title: ASSOCIATED_TENANTS, value, row, ...props })
  }, [props, row, tenantClaimModal, value])
  const getLinkContent = useMemo(() => {
    switch (flowType) {
      case ASSOCIATED_TENANTS: {
        return (
          <div
            className={`tw-flex tw-flex-row tw-border tw-border-indigo-500 tw-border-b-4  tw-gap-2 ${value?.length > 0 ? 'tw-cursor-pointer' : 'tw-cursor-auto'}`}
            onClick={openTenantInfoDialog} style={{ minHeight: '3rem' }}>
            <Body addClassName={'tw-text-blue-600 tw-truncate'}><Bold>{ value.length > 0 ? value.length : ''}</Bold></Body>
          </div>)
      }
      default: {
        return (
          <Body style={{ minHeight: '3rem' }} size="sm" addClassName="tw-text-blue-600 tw-truncate">
            <Bold>{getAppName(value, value)}</Bold>
          </Body>)
      }
    }
  }, [openTenantInfoDialog, flowType, value, getAppName])

  return getLinkContent

}

export default LinkRenderer
